import {
  RawVolumeListResp,
  VolumeListReq,
} from '#/leaderboard/entities/volume';
import { AsyncResp, requestPapi } from '@paradigm/api/src/fetch-api';
import { getQueryString } from '@paradigm/api/src/internal/utils';
import { getUtcDate } from '@paradigm/utils/src/date';
import { Maybe } from '@paradigm/utils/types';

export async function listLeaderboardVolume(
  req: VolumeListReq,
): AsyncResp<RawVolumeListResp> {
  const query = getQueryString([
    ['currencies', getStringList(req.currencies)],
    ['instrument_kinds', getStringList(req.instrumentKinds)],
    ['protocols', getStringList(req.protocols)],
    ['venues', getStringList(req.venues)],
    ['start', getUtcDate(req.start)?.getTime()],
    ['end', getUtcDate(req.end)?.getTime()],
  ]);

  const resp = await requestPapi<RawVolumeListResp>({
    url: `/v1/leaderboard/trade_volume/${query}`,
    method: 'GET',
    signal: req.signal,
  });

  return resp;
}

function getStringList<T extends string>(list?: Maybe<readonly T[]>) {
  return list != null && list.length > 0 ? list.join(',') : null;
}
